import { useAct } from 'FlowTaker/store'
import InlineEditableField from './InlineEditableField'
import useFlowTranslate from 'FlowBuilder/hooks/useFlowTranslate'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'

export default function FieldEdit({ slug }) {
  const act = useAct()

  const field = useSel(s => s.taker.flowTemplate.fields.find(f => f.slug === slug))
  const value = useSel(s => s.taker.flow.templateFields[slug])

  const actionId = useSel(s => s.taker.flowTaker.currentActionId)
  const { fallback: { [_.camelCase(slug)]: translatedValueAction } } = useActionTranslate({ actionId })
  const { fallback: { [_.camelCase(slug)]: translatedValueFlow } } = useFlowTranslate({ actionId })

  if (!field.translatable) {
    return <span>Warning: Inline editable fields must be translatable</span>
  }

  function handleClick(e) {
    const fieldKind = field.actionTextContent ? 'templateActionField' : 'templateFlowField'

    act.taker.postMessageToParent('FIELD_EDIT_CLICK', { field: { ...field, fieldKind }, slug, actionId })
    e.stopPropagation();
  }

  return <InlineEditableField
    field={field}
    value={translatedValueAction || translatedValueFlow || value}
    onClick={handleClick}
    translatable={field?.translatable ?? false}
  />
}

